import { onError } from '@apollo/client/link/error'
import { getAuthConfig, logout } from '@babylon/babylon-auth'
import { getStore } from '@/config/redux'
import { ParsedGraphQLError } from '@/types/graphql'
import { resetUserProfile } from '@/redux/userProfile/actions'

const getStatusCode = (errors: ParsedGraphQLError[]) => {
  const { logoutStatusCodes } = getAuthConfig()

  const errorCodes = errors?.find((error: ParsedGraphQLError) =>
    logoutStatusCodes.includes(error.status!)
  )

  return errorCodes
}

export default onError(({ graphQLErrors }) => {
  const { dispatch } = getStore()
  const graphQlCallUnauthorised = getStatusCode(
    graphQLErrors as ParsedGraphQLError[]
  )

  // SessionStorage required for cypress tests guarding the call to clear
  // SessionStorage when running cypress tests
  if (!window.Cypress && graphQlCallUnauthorised) {
    logout({ redirect: false })
    sessionStorage.clear()
    dispatch(resetUserProfile())
    // Reloading the window, the signup orchestrator will redirect the user to the
    // beginning of the current flow and will avoid redireciton loops
    window.location.reload()
  }
})
